import React, { FC } from 'react';
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  InputAdornment,
  OutlinedInput,
} from '@material-ui/core';
import { MAX_INPUT_LENGTH } from '../../constants/common';
import SendIcon from '@material-ui/icons/Send';
import useStyles from './styles';

interface ICustomInputToolbar {
  text: string | null | undefined;
  onChange: (value: string) => void;
  onSend: () => void;
  loading?: boolean;
  disabled?: boolean;
}

const CustomInputToolbar: FC<ICustomInputToolbar> = (props) => {
  const { text, onChange, onSend, loading, disabled } = props;

  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="row" mt={2}>
      <OutlinedInput
        multiline
        fullWidth
        value={text ?? ''}
        onChange={(e) => {
          onChange(e?.target?.value ?? '');
        }}
        endAdornment={
          !!text?.length && (
            <InputAdornment position="end">
              <Chip
                size="small"
                label={`${text?.length ?? 0} / ${MAX_INPUT_LENGTH}`}
              />
            </InputAdornment>
          )
        }
        style={{ flex: 1 }}
        labelWidth={0}
        rowsMax={12}
      />
      <Button
        disabled={!text?.length || loading || disabled}
        onClick={() => onSend()}
        className={classes.sendButton}>
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          <SendIcon fontSize="large" />
        )}
      </Button>
    </Box>
  );
};

export default CustomInputToolbar;
